"use strict";'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var f = require('react');
require('react/jsx-runtime');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var f__default = /*#__PURE__*/_interopDefaultLegacy(f);

var a=(r,e,n)=>{let o=-1,s=-1;return {setStart:()=>{e!=null&&e.enabled&&(o=performance.now(),e.performance[r]||(e.performance[r]={instances:0,renders:0,msTotal:0,msMin:Number.MAX_SAFE_INTEGER,msMax:0}));},setEnd:()=>{if((e==null?void 0:e.enabled)&&o!==-1){s=performance.now();let t=s-o;e.performance[r].instances+=Number(n.current),e.performance[r].renders++,e.performance[r].msTotal+=t,e.performance[r].msMin=Math.min(t,e.performance[r].msMin),e.performance[r].msMax=Math.max(t,e.performance[r].msMax),n.current=!1;}}}},b=(r,e)=>{let n=f.useRef(!0);return a(r,e,n)};var m=()=>{},d=f__default["default"].createContext({enabled:!1,performance:{},reset:m});var g=()=>{let r=f.useContext(d);return process.env.NODE_ENV==="development"&&r===void 0?(console.warn("TelemetryContext could not be found."),{performance:{}}):r};

exports.a = b;
exports.b = g;
